<template>
	<div @click.prevent="saveSearch">
		<input-button :btn-class="'btn-grey'">
			<slot></slot>
		</input-button>
	</div>
</template>

<script>	
	import InputButton from '../reusable/InputButton'

	export default {
		name: 'SaveSearch',
		components: {
			InputButton
		},
		methods: {
			saveSearch() {
				
				var a = document.createElement('a');
				a.href = 'data:text/plain;charset=utf-8,' + JSON.stringify(this.search);
				a.target = '_blank';
				a.download = (new Date).getTime() + '.txt';
				document.body.appendChild(a);
				a.click();

			}
		},
		props: ['search']
	}
</script>

<style lang="scss" scoped>
	
</style>
